import { useEffect, useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { CONTACT_LIST_URL } from "../../global/API";
import Pagination from "rc-pagination";
import Cookies from "js-cookie";

const Contacts = () => {
  const [contactsList, setContactsList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [filteredValues, setFilteredValues] = useState({
    searchValue: "",
  });
  const [paginationObj, setPaginationObj] = useState({
    pageSize: 30,
    current: 1,
  });

  const fetchData = async (current, pageSize = paginationObj.pageSize) => {
    const { searchValue } = filteredValues;
    setIsLoading(true);
    const jwtToken = Cookies.get("jwtToken");
    const options = {
      method: "GET",
      headers: { Authorization: `Bearer ${jwtToken}` },
    };
    const URL = CONTACT_LIST_URL + `?limit=${pageSize}&page=${current}&search=${searchValue}`;
    try {
      const response = await fetch(URL, options);
      if (response.ok) {
        const data = await response.json();
        setContactsList(data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData(paginationObj.current, paginationObj.pageSize);
  }, []);

  useEffect(() => {
    const { searchValue } = filteredValues;

    if (searchValue.length >= 3 || searchValue === "") {
      const timeout = setTimeout(() => {
        fetchData(1, paginationObj.pageSize);
      }, 300);
      return () => clearTimeout(timeout);
    }
  }, [filteredValues.searchValue]);

  const filterGrid = (e) => {
    const { name, value } = e.target;
    setFilteredValues({
      ...filteredValues,
      [name]: value,
    });
  };

  const paginationChange = (current, pageSize) => {
    setPaginationObj({ ...paginationObj, current });
    fetchData(current, pageSize);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const agentListView = () => {
    return contactsList.data.map((agents) => {
      const { id, agentFirstName, agentLastName, agentCellPhone, agentOfficePhone, agentPhotoURL, agentTitle, username } = agents;
      return (
        <tr key={id}>
          <td style={{ width: "10px", paddingRight: "0" }}>
            <div className="form-check">
              <input type="checkbox" className="form-check-input" />
              <label className="form-check-label"></label>
            </div>
          </td>
          <td>
            <div className="d-flex align-items-center gap-2">
              <div>
                <img src={agentPhotoURL} alt="" style={{ objectFit: "cover", objectPosition: "top center" }} className="avatar-md full-rounded" />
              </div>
              <div>
                <a href="#!" className="text-dark fw-medium fs-15">
                  {agentFirstName}&nbsp;{agentLastName}
                </a>
              </div>
            </div>
          </td>
          <td>{agentTitle}</td>
          <td>
            <a href={`mailto:${username}`}>{username}</a>
          </td>
          <td>
            <a href={`tel:+1${agentCellPhone}`}>{agentCellPhone}</a>
          </td>
          <td>
            <a href={`tel:+1${agentOfficePhone}`}>{agentOfficePhone}</a>
          </td>
          <td className="action-btns">
            <div className="d-flex gap-2">
              <a href="#!" className="btn btn-light btn-sm">
                <Icon icon="solar:eye-broken" className="align-middle fs-18"></Icon>
              </a>
              <button type="button" className="btn btn-soft-danger btn-sm">
                <Icon icon="solar:trash-bin-minimalistic-2-broken" className="align-middle fs-18" />
              </button>
            </div>
          </td>
        </tr>
      );
    });
  };

  const agentsLoadingView = () => {
    return (
      <tr className="loading-hover">
        <td className="property-loader preloader">
          <div class="loading">
            <div class="loading__letter">L</div>
            <div class="loading__letter">o</div>
            <div class="loading__letter">a</div>
            <div class="loading__letter">d</div>
            <div class="loading__letter">i</div>
            <div class="loading__letter">n</div>
            <div class="loading__letter">g</div>
            <div class="loading__letter">.</div>
            <div class="loading__letter">.</div>
            <div class="loading__letter">.</div>
          </div>
        </td>
      </tr>
    );
  };

  const noAgentsView = () => {
    return (
      <tr className="loading-hover">
        <td className="no-data-found">
          <i className="ri-user-search-line fs-22 text-primary avatar-title"></i>
          No Agent Found
        </td>
      </tr>
    );
  };

  const renderView = () => {
    if (isLoading) {
      return agentsLoadingView();
    } else if (contactsList.status === "Not Found") {
      return noAgentsView();
    } else if (contactsList.status === "Success") {
      return agentListView();
    }
  };

  return (
    <div className="page-content agents-page">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">All Contacts</h4>

              <div className="page-title-box-content">
                <button
                  type="button"
                  className="refresh-button"
                  title="Reset"
                  onClick={() => {
                    setFilteredValues({
                      searchValue: "",
                    });
                  }}
                >
                  <i className="ri-refresh-line"></i>
                </button>

                <form className="app-search">
                  <div className="position-relative">
                    <input type="search" className="form-control border-0" placeholder="Search..." autoComplete="off" value={filteredValues.searchValue} onChange={filterGrid} name="searchValue" />
                    <i className="ri-search-line search-widget-icon"></i>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="table-responsive">
                <table className="table align-middle text-nowrap table-hover table-centered property-table">
                  <thead className="bg-light-subtle">
                    <tr>
                      <th style={{ width: "10px" }}>
                        <div className="form-check">
                          <input type="checkbox" className="form-check-input" />
                          <label className="form-check-label"></label>
                        </div>
                      </th>
                      <th>Photo & Name</th>
                      <th>Title</th>
                      <th>Email</th>
                      <th>Cell Phone</th>
                      <th>Office Phone</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>{renderView()}</tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div className="pagination-grid">
          <Pagination total={contactsList.pagination !== undefined ? contactsList.pagination.total : 0} pageSize={paginationObj.pageSize} current={paginationObj.current} onChange={paginationChange} />
        </div>
      </div>
    </div>
  );
};

export default Contacts;
